import styled from 'styled-components';
import BgCardPass from '../../assets/images/bg-card-pass.png';
import BgCardVip from '../../assets/images/bg-card-vip.png';
import BgCardOn from '../../assets/images/bg-card-on.png';

interface ButtonProps {
  bgColor?: string;
}
interface IconProps {
  color?: string;
}

export const Container = styled.div`
  height: 100vh !important;
  .page-container {
    background-color: #0c0013;
    color: #fff;
  }

  .container {
    max-width: 1440px;
  }

  .container-tickets {
    gap: 35px;
  }

  .page-title {
    h2 {
      font-size: 28px;
      color: #9000ff;
      font-weight: bold;
      text-transform: uppercase;
    }

    h1 {
      font-size: 46px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .custom-card {
    width: 404px;
    height: 667px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 18px;
  }

  .card-pass {
    width: 383px;
    height: 631px;
    background-image: url(${BgCardPass});
    background-repeat: no-repeat;
    background-size: cover;
    padding: 35px;
    border: 1px solid #921174;
    border-radius: 16px;
  }

  .card-vip {
    width: 383px;
    height: 631px;
    background-image: url(${BgCardVip});
    background-repeat: no-repeat;
    background-size: cover;
    padding: 35px;
    border: 1px solid #9000ff;
    border-radius: 16px;
  }

  .custom-card-on {
    width: 404px;
    height: 482px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 18px;
    padding: 11px;
  }

  .card-on {
    width: 383px;
    height: 446px;
    background-image: url(${BgCardOn});
    background-repeat: no-repeat;
    background-size: cover;
    padding: 35px;
    border: 1px solid #3d7ff9;
    border-radius: 16px;
  }

  .title-container {
    display: flex;
    align-items: center;
    font-size: 1.68rem;
  }

  .divider {
    width: 1px;
    height: 32px;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 20px;
  }

  .light-text {
    font-family: 'Poppins', sans-serif;
    font-weight: 300;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    text-transform: uppercase;
  }

  .horizontal-divider {
    background-color: rgba(255, 255, 255, 0.5);
    opacity: 40%;
  }

  .discount-badge {
    background: #2eab5f;
    color: white;
    font-size: 15px;
    padding: 6px 12px;
    border-radius: 6px;
    display: inline-block;
  }
  .original-price {
    text-decoration: line-through;
    font-size: 1rem;
  }

  .final-price {
    font-size: 18px;
    font-weight: 300;
    span {
      font-size: 28px;
      font-weight: bold;
    }
    margin: 0;
  }
  .payment-info {
    font-size: 13.55px;
    color: #b5b5b5;
  }
  .benefits li {
    font-size: 16px;
    margin-top: 5px;
  }

  .close {
    float: left;
    color: #921174;
  }

  .sold-out {
    height: auto;
    padding: 18px 0;
    border-color: rgba(255, 255, 255, 0.09);
    opacity: 0.6;

    .card-vip,
    .card-pass {
      height: auto;
      border-color: rgba(255, 255, 255, 0.09);
    }
  }

  .sold-out-badge {
    display: block;
    margin-top: 12px;
    padding: 12px 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 80px;
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.45);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: center;
    text-transform: uppercase;
    cursor: default;
  }

  @media only screen and (max-width: 768px) {
    .page-title {
      h2 {
        font-size: 26px;
        color: #9000ff;
        font-weight: bold;
        text-transform: uppercase;
      }

      h1 {
        font-size: 38px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
`;

export const ButtonCard = styled.button<ButtonProps>`
  margin: auto;
  padding: 12px 40px;
  border: none;
  border-radius: 27px;
  background-color: ${(props) => props.bgColor};
  color: #fff;
  font-size: 21px;
  text-transform: uppercase;
  font-weight: bold;
`;

export const IconCustom = styled.i<IconProps>`
  color: ${(props) => props.color};
  vertical-align: middle;
`;
